module.exports = __webpack_public_path__ + "img/nolanovel_icon.e3296e70.png";